// extracted by mini-css-extract-plugin
export default {"card":"Card_card__n5BrZ","cardPostDate":"Card_cardPostDate__K6jMJ","cardSummary":"Card_cardSummary__IDGuC"};